import { render, staticRenderFns } from "./MicroLesson.vue?vue&type=template&id=c8e81c94&scoped=true&"
import script from "./MicroLesson.vue?vue&type=script&lang=js&"
export * from "./MicroLesson.vue?vue&type=script&lang=js&"
import style0 from "./MicroLesson.vue?vue&type=style&index=0&id=c8e81c94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e81c94",
  null
  
)

export default component.exports